export const bistrochatLinks = {
  braza: 'https://book.bistrochat.com/brazachurrascaria',
  tango: 'https://book.bistrochat.com/tango-argentinian-steakhouse-lkf',
  ['bouchon-bistro']: 'https://book.bistrochat.com/bouchonbistrofrancais',
  ['harbourside-grill']: 'https://book.bistrochat.com/harboursidegrill',
  ['bombay-dreams']: 'https://book.bistrochat.com/bombaydreams',
  spiga: 'https://book.bistrochat.com/spiga',
  alto: 'https://book.bistrochat.com/alto',
  boticario: 'https://book.bistrochat.com/boticario',
  fiamma: 'https://book.bistrochat.com/fiamma',
  dragonfly: 'https://book.bistrochat.com/dragonfly'
}

export const bistrochatSlugs = ['braza', 'tango', 'bouchon-bistro', 'harbourside-grill', 'bombay-dreams', 'spiga', 'alto', 'boticario', 'fiamma', 'dragonfly']